import ModalWrapper from '../../common/Modal/ModalWrapper'
import { toggleModal } from '../../../reducers/modalReducer';
import Button from '../../common/Button';
import { postRequest, showMessage } from '../../../config';
import { setCompany } from '../../../reducers/companyReducer';

const FirstSetupDataRepositoryModal = ({ modalType, dispatch, companyId, company }) => {

    const handleVisitedDataRepo = async () => {
        try {
            dispatch(toggleModal({ open: '' }))
            dispatch(setCompany({ ...company, firstVisitRepository: true }))
            localStorage.setItem('firstVisitRepository', true)
            const res = await postRequest('/company/updateFirstVisitDataRepo', { companyId })
        } catch (err) {
            showMessage(err.message)
        }
    }

    return (
        <ModalWrapper modalType={modalType} modalCardClasses={"maw1300px FirstSetupData bg38"} onCloseHandler={handleVisitedDataRepo}>
            <div className="df fdc">
                <p className="c15 fs1-5rem fw500">How to populate our Data Repository</p>
                <h1 className="c3 fs1-25rem fw500 mb2rem">First time?</h1>
            </div>
            <div class='w100 df jcc mb2rem'>
                <img className='' src={require('../../../../images/dataRepo/four-steps.png')} alt='steps' />
            </div>
            <div className="w100 df jcc">
                <img className='mx0-5rem' src={require('../../../../images/dataRepo/first-time-repository-1.png')} alt='first-time-repository-1' />
                <img className='mx0-5rem' src={require('../../../../images/dataRepo/first-time-repository-2.png')} alt='first-time-repository-2' />
                <img className='mx0-5rem' src={require('../../../../images/dataRepo/first-time-repository-3.png')} alt='first-time-repository-3' />
                <img className='mx0-5rem' src={require('../../../../images/dataRepo/first-time-repository-4.png')} alt='first-time-repository-4' />
            </div>
            <div className='mt2rem w100 fs1rem df jcc'>
                <Button btnType="warning" customClassName="w20 cp" text={"Let’s Go!"} onClick={handleVisitedDataRepo} />
            </div>
        </ModalWrapper>
    )
}

export default FirstSetupDataRepositoryModal